import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconShield.module.css';

const IconShield = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.80002 12.7999L11.2 15.1999L15.2 9.5999M21.6 11.9999C21.6 13.3527 20.9284 14.5487 19.9005 15.2726C20.1153 16.5112 19.7445 17.8316 18.788 18.7881C17.8315 19.7446 16.5112 20.1154 15.2726 19.9006C14.5487 20.9284 13.3528 21.5999 12 21.5999C10.6473 21.5999 9.45146 20.9285 8.72754 19.9007C7.48872 20.1157 6.16808 19.745 5.21144 18.7883C4.25481 17.8317 3.88402 16.5111 4.09908 15.2723C3.07139 14.5483 2.40002 13.3525 2.40002 11.9999C2.40002 10.6472 3.07145 9.45139 4.0992 8.72746C3.88426 7.48875 4.25507 6.16826 5.21162 5.21171C6.16818 4.25514 7.4887 3.88434 8.72742 4.0993C9.45134 3.07142 10.6473 2.3999 12 2.3999C13.3527 2.3999 14.5486 3.07137 15.2725 4.09917C16.5113 3.88411 17.832 4.2549 18.7886 5.21153C19.7452 6.16815 20.116 7.48877 19.901 8.72756C20.9287 9.4515 21.6 10.6473 21.6 11.9999Z"
        stroke="#535763"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconShield.defaultProps = {
  className: null,
  rootClassName: null,
};

IconShield.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconShield;
